import { Injectable } from '@angular/core'
import { ProductGroupedService } from 'src/app/asignacion-menu/servicios-alimentos/product-grouped-services'
import { GraphService } from 'src/app/services/api/graph.service'

@Injectable({
  providedIn: 'root'
})
export class ProductService {
  constructor (private readonly graphService: GraphService) {}

  queryGetAllServicesFromAgrupadoByCategory (categoriaServicio: string) {
    return this.graphService.queryGraphQLProduct<{
      getAllServicesFromAgrupadoByCategory: any[]
    }>({
      query: `query GetAllServicesFromAgrupadoByCategory($categoriaServicio:String!) {
        getAllServicesFromAgrupadoByCategory(categoriaServicio:$categoriaServicio) {
          id,
          idProducto,
          idServicio,
          nombreServicio,
          categoriaServicio,
          nombreServicio,
          nombreProducto,
          nombreProveedor,
          serviceDay,
          menu {
            nombreMenu
          }
        }
      }`,
      variables: { categoriaServicio }
    })
  }

  queryGetAllServicesFromAgrupadoByType ({
    tipoServicio
  }: {
    tipoServicio: string
  }) {
    return this.graphService.queryGraphQLProduct<{
      getAllServicesFromAgrupadoByType: any[]
    }>({
      query: `query GetAllServicesFromAgrupadoByType($tipoServicio:String!) {
        getAllServicesFromAgrupadoByType(tipoServicio:$tipoServicio) {
          id,
          idProducto,
          idServicio,
          nombreServicio,
          categoriaServicio,
          nombreProducto,
          nombreProveedor,
          serviceDay,
          yearProduct,
          menu {
            nombreMenu
          }
        }
      }`,
      variables: { tipoServicio }
    })
  }

  queryGetAllServicesFromAgrupado () {
    return this.graphService.queryGraphQLProduct<{
      getAllServicesFromAgrupado: any[]
    }>({
      query: `query {
        getAllServicesFromAgrupado {
          id,
          idProducto,
          idServicio,
          nombreServicio
        }
      }`,
      variables: {}
    })
  }

  queryGetProductById ({ productId }: { productId: string }) {
    return this.graphService.queryGraphQLProduct<{
      getProductById: {
        id: string
        nombre: string
      }
    }>({
      query: `query GetProductById($id:String!){
        getProductById(id:$id) {
          id,
          nombre
        }
      }`,
      variables: { id: productId }
    })
  }

  mutationUpdateProductoAgrupado ({ id, update }: { id: string; update: any }) {
    return this.graphService.mutateGraphQLProduct<{
      updateProductoAgrupado: any
    }>({
      mutation: `mutation UpdateProductoAgrupado($id:String!, $update: ServicesOfProduct!) {
        updateProductoAgrupado(id:$id, update: $update) {
          id
          menu {
            nombreMenu
          }
        }
      }`,
      variables: { id, update }
    })
  }

  mutationReplicateMenusFromAllGroupedServicesFromOtherYear ({
    yearOfMenusToBeCopied,
    yearOfMenusToBeApplied
  }: {
    yearOfMenusToBeCopied: number
    yearOfMenusToBeApplied: number
  }) {
    return this.graphService.mutateGraphQLProduct<{
      replicateMenusFromAllGroupedServicesFromOtherYear: ProductGroupedService[]
    }>({
      mutation: `mutation ReplicateMenusFromAllGroupedServicesFromOtherYear(
          $yearOfMenusToBeCopied: Int!, $yearOfMenusToBeApplied: Int!
        ) {
          replicateMenusFromAllGroupedServicesFromOtherYear (
            yearOfMenusToBeCopied: $yearOfMenusToBeCopied, yearOfMenusToBeApplied: $yearOfMenusToBeApplied
          )
        }`,
      variables: {
        yearOfMenusToBeCopied,
        yearOfMenusToBeApplied
      }
    })
  }
}
